import { createContext, useContext } from "react";

export const AppContext = createContext({ openApp: () => {} });
export const useApp = () => useContext(AppContext);

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/bf7b2ed5-af3c-4d01-b142-12183abbfa96/images/e8e9defb751638177c1308b33ddc5275336d1ff465c0ceae4438b5e7311be3ab.png",
  pour: "https://static.prod-images.emergentagent.com/jobs/bf7b2ed5-af3c-4d01-b142-12183abbfa96/images/5deda199f449badab95019bda60909affd81916e485c469a4009c9bf73ee3d9d.png",
  book: "/media/book-cover.jpg",
  woman: "/media/vessels.jpg",
  couple: "/media/couple.jpg",
  dinner: "/media/table.jpg",
  linenLight: "https://images.pexels.com/photos/7114134/pexels-photo-7114134.jpeg?auto=compress&cs=tinysrgb&w=1600",
  clayHands: "https://images.unsplash.com/photo-1609881582722-4a8ab7cd54d8?auto=format&fit=crop&w=1100&q=80",
  reflectionSinger: "/media/reflection-night.jpg",
  reflection2: "/media/reflection-2.jpg",
  reflection3: "/media/reflection-3.jpg",
  reflectionPaint: "/media/reflection-paint.jpg",
  prayer: "/media/prayer.jpg",
  reflectionEvent: "https://images.unsplash.com/photo-1766393524464-e5eb1b05e4c8?auto=format&fit=crop&w=1400&q=80",
  retreat: "/media/retreat.jpg",
  circle: "/media/circle.jpg",
  founder: "/media/founder.jpg",
  founderSolo: "/media/founder-solo.jpg",
  serving: "/media/boxes.jpg",
  prayingTogether: "/media/pray-hands.jpg",
  prayStreet: "/media/pray-street.jpg",
  wave: "/media/wave.jpg",
  highfive: "/media/highfive.jpg",
  child: "/media/child.jpg",
  hug: "/media/hug.jpg",
  group: "/media/group.jpg",
  circleTalk: "/media/circle-talk.jpg",
  mic: "/media/mic.jpg",
  bike: "/media/bike.jpg",
  lounge: "/media/lounge.jpg",
  laughHug: "/media/laugh-hug.jpg",
  kids: "/media/kids.jpg",
  girlsNight: "/media/girls-night.jpg",
  laughingThree: "/media/laughing-three.jpg",
  tableHug: "/media/table-hug.jpg",
  brick: "/media/brick.jpg",
  dream: "/media/dream.jpg",
};
